var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.approvalApprovers,"item-text":_vm.render,"clearable":"","return-object":""},on:{"input":_vm.onInput}},'v-combobox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }